const DATE_PREFIX_PATTERN = (
  /(\d{1,2}\s+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)|\d{1,2}\.\d{1,2}\.\d{4}|\d{1,2}:\d{2}h)/i
);

/** Strip DigWatch date prefix from titles like "03 Jul 2026 08:00h - 16:15h — Event name". */
const stripDatePrefixFromTitle = (title) => {
  if (!title || typeof title !== 'string') return '';
  const trimmed = title.trim();
  const separator = trimmed.indexOf(' — ');
  if (separator === -1) return trimmed;

  const prefix = trimmed.slice(0, separator);
  if (!DATE_PREFIX_PATTERN.test(prefix)) return trimmed;

  return trimmed.slice(separator + 3).trim();
};

export const getExternalEventDisplayTitle = (event) => {
  if (!event) return '';
  const original = event.originalTitle || event.original_title;
  if (original) return original;
  return stripDatePrefixFromTitle(
    event.displayTitle || event.title || event.post_title || event.name || ''
  );
};

const dayLabel = (date) => (
  `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`
);

/** Group sessions by calendar day (DD.MM.YYYY), earliest day first. */
function groupByDay(items, { startOf, idOf, titleOf }) {
  if (!Array.isArray(items)) return [];
  const days = new Map();
  for (const item of items) {
    const start = startOf(item);
    if (!start || !idOf(item) || Number.isNaN(start.getTime())) continue;
    const date = dayLabel(start);
    const day = days.get(date);
    if (day) {
      day.sessions.push(item);
    } else {
      days.set(date, { date, event_id: idOf(item), title: titleOf(item) || `Session on ${date}`, sessions: [item], start });
    }
  }
  return [...days.values()]
    .sort((a, b) => a.start - b.start)
    .map(({ start, ...day }) => day);
}

/** WordPress child events carry `start_date` as Unix seconds. */
export const extractWordPressChildEventDates = (childEvents) => groupByDay(childEvents, {
  startOf: (child) => (child.start_date ? new Date(parseInt(child.start_date, 10) * 1000) : null),
  idOf: (child) => child.ID,
  titleOf: (child) => child.post_title,
});

/** FAICON sessions carry `start_date` as an ISO string. */
export const extractFaiconSessionDates = (sessions) => groupByDay(sessions, {
  startOf: (session) => (session.start_date ? new Date(session.start_date) : null),
  idOf: (session) => session.id,
  titleOf: (session) => session.name,
});
